/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actions from './RewardPoints-Actions';

const initialState = {
    balance: {},
    eligibility: 'F',
    selected: {
        points: '',
        amount: '',
    },
};

const rewardPointsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.clearAllRewardsPoints().type:
            return initialState;
        case actions.setRewardsEligibility().type:
            return {
                ...state,
                eligibility: action.data.isEligible || false,
            };
        case actions.setRewardsPoints().type:
            return {
                ...state,
                balance: action.data,
            };
        case actions.setSelectedPointsRewards().type:
            return {
                ...state,
                selected: {
                    amount: action.data.amount,
                    points: action.data.points,
                },
            };
        case actions.clearSelectedRewardsPoints().type:
            return {
                ...state,
                selected: {
                    amount: '',
                    points: '',
                },
            };
        default:
            return state;
    }
};

export default rewardPointsReducer;
